import { makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('settings/reportRules', {
  resource () {
    return {
      id: null,
      media_owner_id: mapped(null),
      media_owner_name: null,
      fault_count_rule: mapped(null),
      time_period_rule: mapped(null),
      repeating_rule: mapped('Fixed')
    }
  }
})
